import React, { useContext } from 'react';
import BasicContext from '../BasicContext';

import { Error } from '../components';
import { keyHasPermission } from '../utils/permissions';

/* 
短信包权限校验，直接包在需要校验权限的组件外层
*/
function Permission(props) {

  const context = useContext(BasicContext);
  const permissions = context.permissions || [];

  const { aclKey, ...restProps } = props;

  return <div>
    {
      keyHasPermission(aclKey, permissions) ?
        <div {...restProps} /> :
        <Error message="无相关权限，请联系管理员开通权限！" />
    }
  </div>
}

export default Permission